var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-code",attrs:{"title":"Wert kopieren"},on:{"click":function($event){return _vm.performCopy()}}},[_c('code',[_vm._v(_vm._s(_vm.displayValue || _vm.copyValue))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon is-small"},[_c('i',{staticClass:"fas fa-copy"})])
}]

export { render, staticRenderFns }